
export const input = inputClass => {
  /** Получаем все инпуты */
  const inputsArr = Array.from(document.querySelectorAll(`.${inputClass}`))
  /** Бежим по массиву с инпутами и вешаем слушателя события input */
  if (inputsArr) {
		setClass(inputsArr)
	}
}

export const select = selectClass => {
	const selectsArr = Array.from(document.querySelectorAll(`.${selectClass}`))
  /** Бежим по массиву с инпутами и вешаем слушателя события input */
  if (selectsArr) {
		setClass(selectsArr)
	}
}

export const toggle = toggleClass => {
  /** Получаем родительский контейнер и массив элементов label */
  const toggleContainer = document.querySelector(`.${toggleClass}`)
  const getToggleLabels = function() {
		/** Если toggleContainer присутствует на странице */
		if (toggleContainer) {
			return toggleContainer.querySelectorAll(`.${toggleContainer.dataset.label}`)
		}
	}

	/** Если toggleContainer присутствует на странице */
  if (toggleContainer) {
		toggleContainer.addEventListener('click', event => {
			/** Делегируем событие клик на дочерний элемент toggle__input */
			if (event.target.classList.contains(toggleContainer.dataset.class)) {
				/** Переключаем у целевого элемента класс active */
				event.target.classList.toggle('active')
				/** Вызываем функцию переключения состояния элементов label
				 * передаём на вход массив элементов label и название их класса
				 */
				setToggleClass(getToggleLabels(), `${toggleContainer.dataset.label}`)
			}
		})
	}
}

/** Получаем на вход массив элементов */
function setClass(elementsArray) {
	elementsArray.forEach(elemenet => {
		elemenet.addEventListener('input', event => {
			/** Если после события поле осталось пустым, то ничего не меняем,
			 * а иначе добавляем к оригинальному классу элемента модификатор --active
			 * оригинальный класс передаём через разметку элемента атрибутом data-class
			 */
			!event.target.value == ''
				? event.target.classList.add(`${event.target.dataset.class}--active`)
				: event.target.classList.remove(`${event.target.dataset.class}--active`)
		})
	})
}

/** Получаем на вход массив и строку */
function setToggleClass(labels, selector) {
	/** Формируем строку с названием класса модификатора (./toggle.scss) */
	const active = `${selector}--active`
	/** бежим по массиву и проверяем каждый элемент на наличие нужного класса
	 * при наличии класс удаляем, при отсутствии, добавляем
	 */
	labels.forEach(label => {
		label.classList.contains(active)
			? label.classList.remove(active)
			: label.classList.add(active)
	})
}
